import Vue, { ComponentOptions } from 'vue';
const template = require('./login.html') as string;
import Utils from '../utils';
import appWebConfig from '../../../../app.web.config';
import OnboardingService from '../services/onboarding-service';
import CommonService from '../services/common-service';
import camelizer from '../../../../services/convertDataStrategies/classes/camelizer';
import { AccountService } from "../../../services/client/classes/accountService";
import { IAccountService } from "../../../services/client/interfaces/iAccountService";
import { MemberProfileStoreService } from '../../../private/javascripts/store/services/classes/memberProfileStoreService';
import { IMemberProfileStoreService } from '../../../private/javascripts/store/services/interfaces/IMemberProfileStoreService';

import MixPanel from "../services/mixpanel";
var emailRE = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

enum Page {
  Email,
  Password,
  ForgotPassword,
  EmailVerification
}

export default {
  template: template,

  data: function () {
    return {
      Enums: {
        Page: Page
      },

      currentPage: Page.Email,

      isValidCredentials: true,

      validationInitiated: false,

      userData: {
        email: "",
        password: "",
        photoUrl: null,
        firstName: ""
      }
    };
  },

  computed: {
    validation: function () {
      return {
        email: emailRE.test(this['userData'].email),
        password: !!this['userData'].password.trim() && this['isValidCredentials']
      }
    }
    },

  methods: {
    sendEmail: function () {
      let accountService: IAccountService = new AccountService();

      this['validationInitiated'] = true;

      if (this['validation'].email) {
        let loginData = {
          email: this['userData'].email
        };

        accountService.login(loginData).done(function (res: any) {
          if (res.code === 'a58') {
            this.$root.showModal('request-invite-modal');
          }
          if (res.message === 'email_verification') {
            this['currentPage'] = Page.EmailVerification;
          }
          if (res.code === 'a59') {
            this['validationInitiated'] = false;
            this['currentPage'] = Page.Password;
            this['userData'].photoUrl = res.data.imgUrl;
            this['userData'].firstName = res.data.firstName;
          }
          if (res.code === 'a57') {
            var nextStepToken = res.data.token;
            var onboardingNextStep = res.data.onboarding_next_step;
            window.location.href = appWebConfig.public.onboarding.host + '?token=' + nextStepToken;
                    }

        }.bind(this));

                /*
        var postData = { email: this['userData'].email };

        $.ajax({
          method: 'POST',
          url: window['clientConfig'].oldSiteAddress + '/?ajax=authentication/checkemail',
          data: $.param(postData),
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          xhrFields: {
            withCredentials: true
          }
        }).done(function (result: any) {
          if (result.success) {
            if (result.next_step == 'request_invite') {
              this.$root.showModal('request-invite-modal');
            }

            if (result.next_step == 'email_verification') {
              this['currentPage'] = Page.EmailVerification;
            }

            if (result.next_step == 'password') {
              this['userData'].photoUrl = result.member_thumbnail;
              this['userData'].firstName = result.member_name;

              this['validationInitiated'] = false;
              this['currentPage'] = Page.Password;
            }

            if (result.next_step == 'redirect_to_onboarding') {
              window.location.href = appWebConfig.public.onboarding.host + '?token=' + result.token;
            }
          }
        }.bind(this));*/
      }
    },
    //todo: change to use new workflow
        forgotPassword: function () {
            let accountService: IAccountService = new AccountService();

            this['currentPage'] = Page.ForgotPassword;

            var postData = { email: this['userData'].email };

            accountService.resetPassword(postData);
    },

    login: function () {
      let accountService: IAccountService = new AccountService();
      let memberProfileStoreService: IMemberProfileStoreService = new MemberProfileStoreService();

      this['validationInitiated'] = true;
      this['isValidCredentials'] = true;

      let directOnboarding = function(onboardingNextStep: number, nextStepToken: string) {
        if (onboardingNextStep != 0) {
          OnboardingService.setOnboardingState(false).then(function () {
            window.location.href = appWebConfig.public.onboarding.host + '?token=' + nextStepToken + '&nextStep=' + onboardingNextStep;
          });
        } else {
          OnboardingService.setOnboardingState(true).then(function () {
            window.location.href = Utils.getQueryParameterByName('returnUrl') || '/';
          });
        }
      };

      if (this['validation'].password) {
        let postData = {
          email: this['userData'].email,
          password: this['userData'].password
        };

        return accountService.login(postData).done(function (res: any) {
          if (res.code === 'a5') {
            let userData = res.data;
                      if (userData) {
              var memberKey = userData.memberKey;
              MixPanel.identify(memberKey);
              let causes : any[] = [];
              return memberProfileStoreService.getMemberProfileData(memberKey).then(function(data) {
                if (data.causes) {
                  data.causes.forEach(function(cause: any) {
                    if (cause.name) {
                      causes.push(cause.name);
                    }
                  });
                }
                MixPanel.setMemberInformation(userData.email, userData.created, userData.сompany,
                                userData.jobTitle, userData.firstName, userData.lastName, userData.jobLocation,
                                userData.primaryPhone, userData.personalEmail, userData.secondaryPhone, causes);
                return directOnboarding(userData.onboardingNextStep, userData.token);
              }).catch(function(err) {
                return directOnboarding(userData.onboardingNextStep, userData.token);
              });
                      }
          } else {
            this['isValidCredentials'] = false;
                    }
        }.bind(this)).fail(function () {
          this['isValidCredentials'] = false;
        }.bind(this));
      }
    }
  }
} as ComponentOptions<Vue>



// WEBPACK FOOTER //
// ./static-content/public/javascripts/components/login.ts